import { ListSortDirection, Sort } from "../../models/api/sort";
import { PayrollEntryTypeDTO, PayrollEntryTypeSTO } from "../../models/payroll-entry-types";
import { BaseApiService } from "../base/base-api.service";

export class PayrollEntryTypesApiService extends BaseApiService<PayrollEntryTypeDTO, PayrollEntryTypeSTO> {
  constructor() {
    super({
      servicePath: "/PayrollEntryTypes",
      loadItemsPath: "/GetPayrollEntryTypes",
      saveItemsPath: "/SavePayrollEntryTypes",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
